import React from "react";

var StarIcon = function StarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.951 9.191A1 1 0 0 0 23 8.5h-7.613l-2.439-7.316a.998.998 0 0 0-1.897 0L8.613 8.5H1a1 1 0 0 0-.588 1.809l6.115 4.448-2.476 7.427a1.001 1.001 0 0 0 1.529 1.131L12 18.729l6.419 4.585a.999.999 0 0 0 1.529-1.131l-2.476-7.427 6.115-4.448a.998.998 0 0 0 .364-1.117z"
  }));
};

StarIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
StarIcon.defaultProps.solid = true;
export default StarIcon;